import React from 'react';
import { Image } from '../../../../components/Image';
import desktopPlaceholder from '../../../../assets/images/daily-wag/daily-wag-desktop-placeholder.jpeg';
import mobilePlaceholder from '../../../../assets/images/daily-wag/daily-wag-mobile-placeholder.jpeg';
export const DailyWagHeroHeaderImage = ({
  heroImageUrl,
  slug
}) => <Image alt={`daily-wag-${slug}-hero-image`} borderRadius={['0px', '8px']}
// TODO figure out why grid isn't being applied to the image
height={['250px', null, '555px']} width={['100%', '500px', '832px']}
/* TODO update image-next to support array and use that instead
of local ./Image component */ src={heroImageUrl || [mobilePlaceholder, null, desktopPlaceholder]} data-sentry-element="Image" data-sentry-component="DailyWagHeroHeaderImage" data-sentry-source-file="index.tsx" />;